import React, { useState } from 'react';
import {
  Title, MenuButton, SidebarContainer, OrDivider, MenuItemsContainer, CloseIcon, SubmitButtonWrapper, Overlay, ModalWrapper, BookingImg,
  DividerText
} from './style';
import bookingSession from '../../static/img/booking-session.svg';
import PurpleBackgroundBtn from '../Buttons/PurpleBackgroundBtn';
import closeicon from '../../static/icons/close-icon.svg';
// This component is used to display the session booking popup
const SessionBookingPopup = ({
  menuItems,
  onSubmit,
  onClose,
}) => {
  const [checkedItems, setCheckedItems] = useState([]);

  const handleCloseDialog = () => {
    if (onClose) {
      onClose();
    }
  }

  const handleCheckboxChange = (index) => {
    // Single-select: clicking a checked item clears it, clicking another swaps.
    // Return [] (not null) so later .includes/.length calls don't NPE.
    setCheckedItems((prev) =>
      prev.includes(index) ? [] : [index]
    );
  };

  const handleSubmit = () => {
    if (onSubmit && checkedItems.length > 0) {
      onSubmit(menuItems[checkedItems[0]]);
    }
  }

  const handleBooking = () => {
    window.open(
      "https://calendly.com/d/ctn2-dp2-rv8/jeddle-faculty-onboarding",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <Overlay>
      <ModalWrapper hasSubmit={checkedItems.length > 0}>
        <SidebarContainer>
          <CloseIcon src={closeicon} alt="close-icon" onClick={handleCloseDialog} />
          <BookingImg><img src={bookingSession} alt="booking-session" /></BookingImg>
          <Title>Book your live faculty onboarding session</Title>
          <PurpleBackgroundBtn
            buttonText={"Book a time now"}
            onClickFn={handleBooking}
            fontWeight={400}
          />
          <OrDivider>
            <DividerText>OR</DividerText>
          </OrDivider>
          <MenuItemsContainer>
            {menuItems.map((item, index) => (
              <MenuButton key={index}>
                <input
                  type="checkbox"
                  checked={checkedItems.includes(index)}
                  onChange={() => handleCheckboxChange(index)}
                />
                <span style={{ color: "#56515B", fontWeight: 400, lineHeight: "24px", fontFamily: '"IBM Plex Sans",sans-serif', fontSize: "16px" }}>{item}</span>
              </MenuButton>
            ))}
          </MenuItemsContainer>
          {checkedItems.length > 0 && (
            <SubmitButtonWrapper>
              <PurpleBackgroundBtn
                buttonText="Submit"
                onClickFn={handleSubmit}
              />
            </SubmitButtonWrapper>
          )}

        </SidebarContainer>
      </ModalWrapper>
    </Overlay>
  );
};

export default SessionBookingPopup;
